export const AfterFirstDigitRegex = /\d.*$/g;
export const BeforeDigitRegex = /^\D+/g;
// Regex: optional digits before decimal, optional decimal with up to 2 digits after
export const moneyPatternRegex = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;
